export const hasNativeWakeLock = () => 'wakeLock' in navigator

export default class WakeLock {
  _lock = null
  _getLock = null
  _enable = false

  get isEnabled () {
    return this._lock && this._enable && !this._lock.released
  }

  _retryLock = () => {
    if (
      document.visibilityState === 'visible' &&
      this._enable
    ) {
      this.enable()
    }
  }

  enable = () => {
    if (!hasNativeWakeLock() || this.isEnabled) {
      return
    }

    this._enable = true

    if (!this._getLock) {
      this._getLock = navigator.wakeLock.request('screen')
        .then((lock) => {
          this._lock = lock
          this._getLock = null
        })
        .catch(() => {
          this._lock = null
          this._getLock = null
        })
    }

    document.addEventListener('visibilitychange', this._retryLock)
    document.addEventListener('fullscreenchange', this._retryLock)
  }

  disable = () => {
    if (!hasNativeWakeLock() || !this._enable) {
      return
    }

    this._enable = false

    document.removeEventListener('visibilitychange', this._retryLock)
    document.removeEventListener('fullscreenchange', this._retryLock)

    const lock = this._getLock || Promise.resolve()
    lock.then(() => {
      if (this._lock) {
        this._lock.release()
        this._lock = null
      }
    })
  }
}

export const getWakeLock = (() => {
  let instance
  return () => {
    if (!instance) {
      instance = new WakeLock()
    }
    return instance
  }
})()



// WEBPACK FOOTER //
// ./src/utils/wakelock.js